import { OrganizationKeyName } from "../../../model/Organization";
import { News } from "../model/NewsSuccessResponse";

export const GET_NEWS_SUCCESS = "SHOP:GET_NEWS_SUCCESS";

export const getNewsSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  data: News
) => ({
  type: GET_NEWS_SUCCESS as typeof GET_NEWS_SUCCESS,
  organization,
  id,
  data,
});

export type GetNewsSuccessAction = ReturnType<typeof getNewsSuccessAction>;
